<template>
    <div class="flex items-center gap-2 bg-[#EBECEC] p-2 rounded-lg mt-4 cursor-pointer">
        <div class="bg-gray-400 rounded-full h-8 w-8 flex items-center justify-center text-white">
            <fa :icon="['fal', 'users']"></fa>
        </div>
        <div class="flex items-center gap-1 text-blue-500">
            <fa :icon="['fal', 'plus']"></fa>
            <span>New group</span>
        </div>
    </div>
</template>

<script setup></script>

<style scoped></style>
